<template>
  
</template>

<script>
import api from '@/services/api';
import encrypt from '@/services/encrypt';
import axios from 'axios';

export default {
  name: 'CheckAccessFanCam',  
  data() {
    return {      
      accessConfig: {},
    };
  },

  methods: {
    async check() {
        const apiFan = axios.create({
            baseURL: 'https://011c5ev8ie.execute-api.us-east-1.amazonaws.com/production/public/external/fancam-token/validate',
        });
        apiFan.get(`?token=${this.$route.params.stream}`)
        .then(async (response) => {
            /*//INICIO TESTE
            console.log(response.data);
            if (!response.data.isValid){
                response.data.isValid = true;
                response.data.email = 'dantfv@gmail.com';
                response.data.name = 'Danton';
            }
            //FIM TESTE
            */
            const check = response.data;  
            console.log('check',check);          
            if (check.isValid){
                //Create user and login
                console.log('Register');                
                api
                .post(`event/${this.$store.state.eventId}/user`, {
                    email: check.email.toLowerCase().trim(),
                    password: await encrypt(check.email.toLowerCase().trim()),
                    name: check.name,
                    sendEmail: false,
                    valid:true,
                    login: true,
                })
                .then((response) => {
                    console.log('Register user',response.data); 
                    this.$store.commit({
                        type: 'setUser',
                        userData: response.data,
                    });

                    this.$router
                    .push({
                        name: this.accessConfig.firstPage,
                        params: this.accessConfig.firstPageParams,
                    })
                    .catch((err) => {
                        console.log('navigation error', err);
                        alert('Falha em navegação.');
                    });
                    this.$emit('close');
                })
                .catch(async (err, data) => {     
                    console.log('Erro',err,data);               
                    if (err.response.data.error) {
                        if (err.response.data.error.includes('Email already in database')) {
                            api
                            .post(`event/${this.$store.state.eventId}/login`, { email: check.email.toLowerCase().trim(), password: await encrypt(check.email.toLowerCase().trim()), })
                            .then((response) => {
                                console.log('Login user',response.data); 
                                this.$store.commit({
                                    type: 'setUser',
                                    userData: response.data,
                                });
                                this.$router
                                .push({
                                    name: this.accessConfig.firstPage,
                                    params: this.accessConfig.firstPageParams,
                                })
                                .catch((err) => {
                                    console.log('navigation error', err);
                                    alert('Falha em navegação.');
                                });
                                this.$emit('close');
                            })
                            .catch((err, data) => {
                                console.log('error', err.response, data);
                                alert('Access denied.');    
                            })  
                        } else {
                            console.log('error', err.response, data);
                            alert('Access error - failed on login.');
                        }
                    } else {
                        console.log('error', err.response, data);
                        alert('Access error: failed on login.');
                    }
                });
            }else{
                alert('Access error');
                //Show error page
            }
        })
        .catch((err, data) => {
              console.log('error', err.response, data)
        });
//https://brwfehor5i.execute-api.us-east-1.amazonaws.com/staging/public/external/fancam-token/validate?token=U2FsdGVkX1_pqDf094Doy5SDIEQTVghaAOV9wfMLwfIgRSdaZWolsNwFpo5d2z1DceUzyNGtDKDdLOyI9pK3xg
/*OK 200:
 
{
    "isValid": true,
    "email": "marco.antonio@sioux.com.br",
    "name": "Marco"
}
 
 
FALHA 200:
{
    "isValid": false,
    "email": null,
    "name": null
}
 */                     
    },
  },
  mounted() {
    this.check();
  },
  beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
  },
};
</script>

